import React, { SVGProps } from "react";
import { LucideIcon } from "lucide-react";
import { useTheme } from "styled-components";
import { getNewLookTokens } from "common/NewLook/tokens.ts";

interface EmptyIllustrationProps extends SVGProps<SVGSVGElement> {
  icon: LucideIcon;
}

const ICON_SIZE = 26;

/**
 * The new look's quiet empty-state mark: a line icon on a hairline tile over
 * a soft well, all in neutral greys (colour is kept for meaning).
 */
const EmptyIllustration = ({
  icon: Icon,
  ...props
}: EmptyIllustrationProps) => {
  const theme = useTheme();
  const tokens = getNewLookTokens(theme);
  return (
    <svg viewBox="0 0 160 120" fill="none" aria-hidden="true" {...props}>
      <circle cx="80" cy="60" r="48" fill={tokens.well} />
      <rect
        x="56.5"
        y="36.5"
        width="47"
        height="47"
        rx="12"
        fill={tokens.panel}
        stroke={tokens.hairlineStrong}
      />
      <Icon
        x={80 - ICON_SIZE / 2}
        y={60 - ICON_SIZE / 2}
        color={tokens.secondary}
        strokeWidth={1.75}
        style={{ width: ICON_SIZE, height: ICON_SIZE }}
      />
    </svg>
  );
};

export const createEmptyIllustration =
  (icon: LucideIcon) => (props: SVGProps<SVGSVGElement>) =>
    <EmptyIllustration icon={icon} {...props} />;

export default EmptyIllustration;
